import {S} from '../engine/state';

export const PRESETS:any={
 leicht:{crisis:true,court:false,lobby:false,infl:true,demo:true,wings:false,scandal:true,events:true},
 normal:{crisis:true,court:true,lobby:true,infl:true,demo:true,wings:true,scandal:true,events:true},
 schwer:{crisis:true,court:true,lobby:true,infl:true,demo:true,wings:true,scandal:true,events:true},
};
export const CFGN:any={crisis:['Krisen mit Entscheidungen','Gaskrise, Bankenpleite, Pandemie, Großstreik: Ihr müsst unter Zeitdruck entscheiden.'],
 court:['Verfassungsgericht','Die Opposition klagt gegen Gesetze und Haushalte. Karlsruhe kann sie kippen.'],
 lobby:['Verbände und Gewerkschaften','Vier Verbände bewerten eure Politik und reagieren mit Streiks, Kampagnen oder Lob.'],
 infl:['Inflation und Zinsen','Hohe Defizite treiben die Preise, die EZB erhöht die Zinsen, die Zinslast steigt.'],
 demo:['Demografischer Wandel','Rente und Pflege werden jedes Jahr von selbst teurer.'],
 wings:['Parteiflügel und Parteitag','Eure Partei hat zwei Flügel, einen Parteitag pro Legislatur und stimmt über Koalitionsverträge ab.'],
 scandal:['Affären von Ministern','Minister geraten in Affären und müssen womöglich zurücktreten.'],
 events:['Zufallsereignisse','Kleinere Ereignisse wie Streiks, Hitzesommer oder gute Konjunkturdaten.']};
export const DIFFN:any={leicht:['Leicht','Weniger Störungen von außen. Gerichte, Verbände und Parteiflügel sind aus, Krisen und Affären selten, die Amtsmüdigkeit gering.'],
 normal:['Normal','Alle Einflüsse sind aktiv und wirken in mittlerer Stärke.'],
 schwer:['Schwer','Alle Einflüsse wirken stärker und häufiger: mehr Krisen, mehr Klagen, schnellere Inflation, unruhigere Verbände.']};
export const CF:any=()=>S.cfg||{diff:'normal',...PRESETS.normal};
export const DI=():number=>({leicht:0,normal:1,schwer:2} as Record<string,number>)[CF().diff]??1;
export const DM:any=()=>[.6,1,1.4][DI()];
export const on=(k:any)=>!!CF()[k];
export const fatigue:any=()=>[1,1.5,2][DI()];
